import React from 'react';
import { ProviderEvidence, Card, DynamicCard } from '@enter/core';

interface EvidenceInfoCardsProps {
    evidence: ProviderEvidence;
    dialogContext: any;
}

export const EvidenceInfoCards: React.FC<EvidenceInfoCardsProps> = ({
    evidence,
    dialogContext,
}) => {
    // Helper function to get display name
    const getDisplayName = (data: any): string => {
        if (!data) return 'N/A';
        
        if (data.name) return data.name;
        if (data.organization) return data.organization;
        if (data.first && data.last) return `${data.first} ${data.last}`.trim();
        if (data.id) return data.id;
        
        return 'N/A';
    };


    return (
        <div style={{ 
            marginBottom: '12px',
            display: 'flex',
            gap: '20px',
            flexWrap: 'wrap',
            width: '100%'
        }}>
            {/* Providers Card */}
            <div style={{ 
                flex: '1 1 0',
                minWidth: '300px',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <Card size="large">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', paddingTop: 0, paddingBottom: 0 }}>
                        <DynamicCard
                            sectionLabel="Billing Provider"
                            valueLabel={getDisplayName(evidence.billingProvider)}
                            data={evidence.billingProvider}
                            dialogContext={dialogContext}
                        />
                        <DynamicCard
                            sectionLabel="Rendering Provider"
                            valueLabel={getDisplayName(evidence.renderingProvider)}
                            data={evidence.renderingProvider}
                            dialogContext={dialogContext}
                        />
                    </div>
                </Card>
            </div>

            {/* Payer & Facility Card */}
            <div style={{ 
                flex: '1 1 0',
                minWidth: '300px',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <Card size="large">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', paddingTop: 0, paddingBottom: 0 }}>
                        <DynamicCard
                            sectionLabel="Payer"
                            valueLabel={getDisplayName(evidence.primaryPayer)}
                            data={evidence.primaryPayer}
                            dialogContext={dialogContext}
                        />
                        <DynamicCard
                            sectionLabel="Facility"
                            valueLabel={getDisplayName(evidence.facility)}
                            data={evidence.facility}
                            dialogContext={dialogContext}
                        />
                    </div>
                </Card>
            </div>

        </div>
    );
};

